import React from 'react';

const PulseSpinner = () => {
  return (
    <svg
      style={{
        margin: 'auto',
        background: 'transparent',
        display: 'block',
        shapeRendering: 'auto',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
      }}
      width="100px"
      height="100px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <rect x="17.5" y="30" width="15" height="40" fill="#0f4c81">
        <animate
          attributeName="y"
          repeatCount="indefinite"
          dur="0.9615384615384615s"
          calcMode="spline"
          keyTimes="0;0.5;1"
          values="20;30;30"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
          begin="-0.19230769230769232s"
        ></animate>
        <animate
          attributeName="height"
          repeatCount="indefinite"
          dur="0.9615384615384615s"
          calcMode="spline"
          keyTimes="0;0.5;1"
          values="60;40;40"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
          begin="-0.19230769230769232s"
        ></animate>
      </rect>
      <rect x="42.5" y="30" width="15" height="40" fill="#177dd6">
        <animate
          attributeName="y"
          repeatCount="indefinite"
          dur="0.9615384615384615s"
          calcMode="spline"
          keyTimes="0;0.5;1"
          values="22.5;30;30"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
          begin="-0.09615384615384616s"
        ></animate>
        <animate
          attributeName="height"
          repeatCount="indefinite"
          dur="0.9615384615384615s"
          calcMode="spline"
          keyTimes="0;0.5;1"
          values="55;40;40"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
          begin="-0.09615384615384616s"
        ></animate>
      </rect>
      <rect x="67.5" y="30" width="15" height="40" fill="#6aa0f1">
        <animate
          attributeName="y"
          repeatCount="indefinite"
          dur="0.9615384615384615s"
          calcMode="spline"
          keyTimes="0;0.5;1"
          values="22.5;30;30"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
        ></animate>
        <animate
          attributeName="height"
          repeatCount="indefinite"
          dur="0.9615384615384615s"
          calcMode="spline"
          keyTimes="0;0.5;1"
          values="55;40;40"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
        ></animate>
      </rect>
    </svg>
  );
};

export default PulseSpinner;
